import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import BackHeader from "@components/header/BackHeader";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { Flex } from "antd";

const CapturePopup = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const cameraInputRef = useRef<HTMLInputElement>(null);

  const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      navigate("/capture", {
        state: {
          image: url, // 화면 표시용
          imageFile: file, // API 업로드용 (파일)
        },
      });
    }
  };

  const handleCameraClick = () => {
    cameraInputRef.current?.click();
  };

  return (
    <>
      <BackHeader title="촬영가이드" />

      <Container>
        <Flex vertical gap="5rem">
          <TitleBox>
            <span>{"이렇게 촬영해주세요!"}</span>
          </TitleBox>

          <StepWrapper>
            <StepTitle>{"1. 옷을 착용하지 않고 촬영해주세요."}</StepTitle>

            <ImageBox>
              <Image src={theme.image.tip_1_1} width="100%" height="100%" />

              <Image src={theme.image.tip_1_2} width="100%" height="100%" />

              <Image src={theme.image.tip_1_3} width="100%" height="100%" />
            </ImageBox>
          </StepWrapper>

          <StepWrapper>
            <StepTitle>
              {"2. 배경은 옷과 대비되는 색 위에 올려주세요."}
            </StepTitle>

            <ImageBox>
              <Image src={theme.image.tip_2_1} width="100%" height="100%" />

              <Image src={theme.image.tip_2_2} width="100%" height="100%" />

              <Image src={theme.image.tip_2_3} width="100%" height="100%" />
            </ImageBox>
          </StepWrapper>

          <StepWrapper>
            <StepTitle>{"3. 옷의 전체 사진을 촬영해주세요."}</StepTitle>

            <ImageBox>
              <Image src={theme.image.tip_3_1} width="100%" height="100%" />

              <Image src={theme.image.tip_3_2} width="100%" height="100%" />

              <Image src={theme.image.tip_3_3} width="100%" height="100%" />
            </ImageBox>
          </StepWrapper>
        </Flex>

        {/* 카메라 촬영용 */}
        <input
          ref={cameraInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleImageSelect}
        />

        <ButtonWrapper>
          <BasicButton
            title="촬영하기"
            width="100%"
            onClick={handleCameraClick}
          />
        </ButtonWrapper>
      </Container>
    </>
  );
};

export default CapturePopup;

const Container = styled.div({
  display: "flex",
  width: "100%",
  gap: "5rem",
  flexDirection: "column",
  padding: "1rem",
  height: " calc(100dvh - 5.6rem)",
});

const TitleBox = styled.div(({ theme }) => ({
  fontSize: "3rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "3rem",
  padding: "0 2rem",
}));

const StepWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  padding: "0 2rem",

  ".ex": {
    color: theme.color.dark_gray,
    fontSize: "1.4rem",
    lineHeight: "1.6rem",
    fontWeight: theme.fontWeight.bold,
    textAlign: "center",
  },
}));

const ImageBox = styled.div({
  width: "100%",
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
});

const StepTitle = styled.div(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2rem",
}));

const ButtonWrapper = styled.div(({ theme }) => ({
  width: "100%",
  zIndex: 10,
  paddingBottom: "1rem",
}));
